/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Health professional who created the entry
 * @export
 * @interface HealthProConsultation
 */
export interface HealthProConsultation {
    /**
     * 
     * @type {string}
     * @memberof HealthProConsultation
     */
    personWithRoleId: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProConsultation
     */
    personRoleType: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProConsultation
     */
    healthProType: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProConsultation
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProConsultation
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProConsultation
     */
    lastName: string;
    /**
     * 
     * @type {boolean}
     * @memberof HealthProConsultation
     */
    official: boolean;
}

/**
 * Check if a given object implements the HealthProConsultation interface.
 */
export function instanceOfHealthProConsultation(value: object): value is HealthProConsultation {
    if (!('personWithRoleId' in value) || value['personWithRoleId'] === undefined) return false;
    if (!('personRoleType' in value) || value['personRoleType'] === undefined) return false;
    if (!('healthProType' in value) || value['healthProType'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('official' in value) || value['official'] === undefined) return false;
    return true;
}

export function HealthProConsultationFromJSON(json: any): HealthProConsultation {
    return HealthProConsultationFromJSONTyped(json, false);
}

export function HealthProConsultationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthProConsultation {
    if (json == null) {
        return json;
    }
    return {
        
        'personWithRoleId': json['personWithRoleId'],
        'personRoleType': json['personRoleType'],
        'healthProType': json['healthProType'],
        'title': json['title'] == null ? undefined : json['title'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'official': json['official'],
    };
}

export function HealthProConsultationToJSON(json: any): HealthProConsultation {
    return HealthProConsultationToJSONTyped(json, false);
}

export function HealthProConsultationToJSONTyped(value?: HealthProConsultation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personWithRoleId': value['personWithRoleId'],
        'personRoleType': value['personRoleType'],
        'healthProType': value['healthProType'],
        'title': value['title'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'official': value['official'],
    };
}

